import { Stack, Heading, Loader, Text } from 'braid-design-system';

export const GenericRepostLoading = () => (
  <Stack space="large">
    <Heading level="3" component="h1">
      Reposting your ad...
    </Heading>

    <Stack space="large">
      <Text>Please do not leave this page.</Text>

      <Loader />
    </Stack>
  </Stack>
);
